<div>
  <div class="w-full flex justify-between items-center">
    <div class="text-cafe text-[20px] sm:text-[25px] font-bold font-['Roboto']">
      {{tittle}}
    </div>
  </div>
    <div class="text-cafe mt-[15px] sm:mt-[25px] text-base font-normal  sm:text-[16px]">
      {{text}}
    </div>
</div>

